<div id="waiter" class="sheet">
  <div class="line">
    <h4 class="upper">{{ 'MENU.STAFF' | translate }}</h4>
    <img class="icon-xl" (click)="confirm(false)" [src]="'close.svg' | themeSource" alt="close" />
  </div>

  <div class="options">
    @if (!loaded) {
      <div class="options-loading">
        <mat-spinner diameter="24"></mat-spinner>
      </div>
    } @else if (options?.length > 0) {
      <mat-select class="options-select" [(value)]="selectedOption">
        @for (option of options; track option) {
          <mat-option [value]="option.id">{{option.name}}</mat-option>
        }
      </mat-select>
    }
  </div>

  <textarea class="note-input" [placeholder]="'WAITER.HELP' | translate" [(ngModel)]="comment"></textarea>

  <button class="btn" (click)="confirm(true)">{{ 'ACTIONS.SUBMIT' | translate }}</button>
  <button class="btn cancel" (click)="confirm(false)">{{ 'ACTIONS.CANCEL' | translate }}</button>
</div>
